import Axios from 'api/client';
import { PaymentAccount } from 'types/domain';
import { PaginatedData } from 'types/pagination';

interface AddPaymentAccountsParams {
    email: string;
    merchant: string;
}

const fetchPaymentAccounts = (accountId: number) =>
    Axios.get<PaginatedData<PaymentAccount>>(`/accounts/${accountId}/payment_accounts`).then(
        response => response.data,
    );

const addPaymentAccounts = (accountId: number, params: AddPaymentAccountsParams) =>
    Axios.post(`/accounts/${accountId}/payment_accounts`, params).then(response => response.data);

export { fetchPaymentAccounts, addPaymentAccounts };
